import React, { memo } from 'react';
import { View, Text } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { TabBar, TabItem } from '@shared/components/TabBar';
import { Divider } from '@shared/components/md-design-system/Layout';
import { dynamicTranslations } from '@shared/utils/dynamicTranslation';
export type TabType = 'activities' | 'documents' | 'visits';

interface GeneralHistoryHeaderProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
}

const GeneralHistoryHeader: React.FC<GeneralHistoryHeaderProps> = memo(({
  activeTab,
  onTabChange
}) => {
  const insets = useSafeAreaInsets();
  const { t } = dynamicTranslations();

  const tabs: TabItem<TabType>[] = [
    { key: 'activities', label: t('history.tabs.activities') },
    { key: 'documents', label: t('history.tabs.documents') },
    { key: 'visits', label: t('history.tabs.visits') },
  ];

  return (
    <View
      style={{ paddingTop: insets.top }}
      className="px-8 pb-6 bg-white mt-5 "
    >
      <Text className="text-4xl font-bold mb-4">
        {t('history.title')}
      </Text>
      <TabBar
        style={{ height: 56 }}
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={onTabChange}
        borderRadius={25}
        gap={12}
        containerClassName="mb-4"
      />
      <Divider />
    </View>
  );
});

export default GeneralHistoryHeader;
